import React from "react"
import { Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Settings from "../../../common/Settings"

const ForeignersVerificarAntecedentesCardView = ({ records, isLoading }) => {
  const { t } = useTranslation("global")
  return (
    <Row>
      {records &&
        records.map((item: any, index: number) => {
          return (
            <Col xs={12} md={4} lg={4} key={index}>
              <Card className="mb-4">
                <Card.Body className="p-0 ">
                  <p className="text-center my-4 ">

                    {item.idFotoFrente && (
                      <img
                        alt=""
                        loading="lazy"
                        className=" img-thumbnail my-2"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          objectPosition: "center",
                        }}
                        onError={(e: any) => {

                          if (
                            e.target.src !==
                            "https://placehold.co/600x400"
                          ) {
                            e.target.src =
                              "https://placehold.co/600x400"
                          }
                        }}
                        id={"image" + index}
                        src={
                          item.idFotoFrente.includes("base64")
                            ? item.idFotoFrente
                            : item.idFotoFrente.includes("/")
                              ? `${Settings.BasePath}haitianos/${item.idFotoFrente}`
                              : `${Settings.BasePath}files/${item.idFotoFrente}`
                        }
                      />
                    )}
                  </p>
                  <p className="text-center my-2 card-text text-uppercase">
                    {`${item.nombres ?? ""} ${item.primerApellido ?? ""} ${item.segundoApellido ?? ""}`}

                    <br />

                    <small>
                      {item.alias1} {item.alias2} {item.alias3}</small>
                    <br />
                    <b>{item.cedula}</b>
                  </p>
                </Card.Body>
                <Card.Footer className="text-center ">
                  {item.violacion &&
                    item.violacion.length > 0 && (
                      <span
                        className="badge bg-danger"
                        title={
                          "Solicitar certificado de no antecedentes judiciales"
                        }
                      >
                        <i className="fa fa-exclamation-triangle me-2"></i>
                        Solicitar certificado de no antecedentes judiciales
                      </span>
                    )}
                  <div
                    className="badge bg-warning  text-wrap"
                    title={"No casos laborales"}
                  >
                    <i className="fa fa-check"></i>
                    <span className="ms-2">No casos laborales</span>
                  </div>
                </Card.Footer>
              </Card>
            </Col>
          )
        })}
    </Row>
  )
}

export default ForeignersVerificarAntecedentesCardView
